import React from 'react';
import { Table } from 'reactstrap';
import ProposalBoxView from '../ProposalBoxView';
import ProposalBoxOTCView from '../ProposalBoxOTCView';
import InstallationLocAddress from '../InstallationLocAddress';

const ExhibitSection = ({
  locations,
  proposalData,
  getBoxSumAmount,
  getInstallationSum,
  getLocationSum,
  getLocationSumAmount,
  getLocationOTCAmount,
  getLocationInstAmount,
  tollFreeNumberExist,
  showTollFreeNumber,
}) => {
  return (
    <>
      <div className="loa-doc-page">
        <h5 className="loa-doc-subtitle">Exhibit A: Services and One-Time Charges Detail</h5>
        <div className="proposalDetails" style={{ marginBottom: '25px' }}>
          {locations &&
            locations.map((location, i) => (
              <div className="no-break">
                <div className="locationRow no-break">
                  <span className="locationRowName">{location.name || ''}</span>
                </div>
                {location.proposalBoxes.map(box => {
                  return (
                    <Table
                      className="tableSecondary text-md-left table-mb-not no-break service-total-table"
                      bordered
                      size="sm"
                    >
                      <thead>
                        <tr className="boxName boxNameView">
                          <th
                            colSpan={4}
                            style={{
                              textAlign: 'center',
                              color: '#212529',
                              border: '1px solid black',
                            }}
                          >
                            {box.boxName || box.defaultBoxName}
                          </th>
                        </tr>

                        <tr className="epikDescriptionRow">
                          <td style={{ width: '65%' }}>EPIK Services Description</td>
                          <td style={{ width: '12.5%' }}>Unit Price</td>
                          <td style={{ width: '10%' }}>Quantity</td>
                          <td style={{ width: '12.5%' }}>Net Price</td>
                        </tr>
                      </thead>
                      <tbody>
                        <ProposalBoxView
                          tollFreeNumber={tollFreeNumberExist}
                          key={box.boxId}
                          box={box}
                          boxTotal={getBoxSumAmount(box, proposalData.priceKey)}
                          priceKey={proposalData.priceKey && proposalData.priceKey.value}
                          productGroups={proposalData ? proposalData.productGroups : {}}
                        />
                      </tbody>
                    </Table>
                  );
                })}
                <div className="emptyTr mrc-row-loc">
                  <span style={{ textAlign: 'right' }} className="mrc-row-name">
                    MRC {location.name || ''}:
                  </span>
                  <span style={{ textAlign: 'right' }} className="viewRowRedColor">
                    ${getLocationSumAmount(location.proposalBoxes, proposalData.priceKey)}
                  </span>
                </div>
              </div>
            ))}

          {locations &&
            locations.map((location, i) => (
              <div className="no-break">
                <div className="locationRow no-break">
                  <span className="locationRowName">{location.name || ''}</span>
                </div>
                {location.proposalBoxes.map(box => {
                  return (
                    <Table
                      className="tableSecondary text-md-left table-mb-not no-break service-total-table"
                      bordered
                      size="sm"
                    >
                      <thead>
                        <tr className="epikDescriptionRow">
                          <td style={{ width: '65%' }}>One-time Charges Description</td>
                          <td style={{ width: '12.5%' }}>Unit Price</td>
                          <td style={{ width: '10%' }}>Quantity</td>
                          <td style={{ width: '12.5%' }}>Net Price</td>
                        </tr>
                      </thead>
                      <tbody>
                        <ProposalBoxOTCView
                          key={box.boxId}
                          box={box}
                          getInstallationSum={getInstallationSum(box)}
                          boxTotal={getLocationSum(box, proposalData.priceKey)}
                          priceKey={proposalData.priceKey && proposalData.priceKey.value}
                          productGroups={proposalData ? proposalData.productGroups : {}}
                        />
                      </tbody>
                    </Table>
                  );
                })}
                <div className="emptyTr mrc-row-loc">
                  <span style={{ textAlign: 'right' }} className="mrc-row-name">
                    Total One-Time Charges {location.name || ''}:
                  </span>
                  <span style={{ textAlign: 'right' }} className="viewRowRedColor">
                    $
                    {(
                      parseFloat(getLocationOTCAmount(location.proposalBoxes, proposalData.price)) +
                      parseFloat(getLocationInstAmount(location.proposalBoxes, proposalData.price))
                    ).toFixed(2)}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="loa-doc-page">
        <h5 className="loa-doc-subtitle">Exhibit B: Locations and Phone Numbers</h5>
        <div className="proposalDetails" style={{ marginBottom: '25px' }}>
          <h5 className="exh-a-subheading">Installation Location Addresses:</h5>
          <div className="no-break">
            <Table
              className="tableSecondary text-md-left table-mb-not no-break service-total-table"
              bordered
              size="sm"
            >
              <thead>
                <tr className="epikDescriptionRow">
                  <td style={{ width: '9%' }}>Location</td>
                  <td style={{ width: '13%' }}>Address</td>
                  <td style={{ width: '6%' }}>Suit</td>
                  <td style={{ width: '9%' }}>City</td>
                  <td style={{ width: '6%' }}>State</td>
                  <td style={{ width: '6%' }}>Zip</td>
                  <td style={{ width: '13%' }}>Site Contact</td>
                  <td style={{ width: '10%' }}>Email</td>
                  <td style={{ width: '9%' }}>Office #</td>
                  <td style={{ width: '9%' }}>Mobile #</td>
                  <td style={{ width: '7%' }}>Fax #</td>
                </tr>
              </thead>
              <tbody>
                {locations &&
                  locations.map((location, i) => {
                    return <InstallationLocAddress location={location} key={i} id={i} />;
                  })}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="proposalDetails" style={{ marginBottom: '25px' }}>
          <h5 className="exh-a-subheading">Designated Action on Existing Phone Numbers:</h5>
          <div className="no-break">
            <Table
              className="tableSecondary text-md-left table-mb-not no-break service-total-table"
              bordered
              size="sm"
            >
              <thead>
                <tr className="epikDescriptionRow">
                  <td style={{ width: '25%' }}>Location Address</td>
                  <td style={{ width: '12%' }}>
                    Action <br />
                    (Port or New)
                  </td>
                  <td style={{ width: '17%' }}>
                    Telephone Number <br />
                    (xxx) xxx-xxxx
                  </td>
                  <td style={{ width: '17%' }}>if a Range, Ending Telephone Number</td>
                  <td style={{ width: '17%' }}>Currently Line Type/Use (fax, fire, alarm, etc.)</td>
                  <td style={{ width: '12%' }}>Current Carrier</td>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, i) => (
                  <tr key={i}>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        <div
          hidden={!showTollFreeNumber}
          className="proposalDetails"
          style={{ marginBottom: '25px' }}
        >
          <h5 className="exh-a-subheading">
            Designated Action on Existing Toll-Free Phone Numbers:
          </h5>
          <div className="no-break">
            <Table
              className="tableSecondary text-md-left table-mb-not no-break service-total-table"
              bordered
              size="sm"
            >
              <thead>
                <tr className="epikDescriptionRow">
                  <td style={{ width: '25%' }}>Location Address</td>
                  <td style={{ width: '12%' }}>
                    Action <br />
                    (Port or New)
                  </td>
                  <td style={{ width: '17%' }}>
                    Telephone Number <br />
                    (xxx) xxx-xxxx
                  </td>
                  <td style={{ width: '17%' }}>if a Range, Ending Telephone Number</td>
                  <td style={{ width: '17%' }}>Currently Line Type/Use (fax, fire, alarm, etc.)</td>
                  <td style={{ width: '12%' }}>Current Carrier</td>
                </tr>
              </thead>
              <tbody>
                {[...Array(2)].map((_, i) => (
                  <tr key={i}>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExhibitSection;
